import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dropdown from './components/Dropdown'

const propTypes = {
  items: PropTypes.array.isRequired,
  selectedItem: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
  ]),
  onSelectChange: PropTypes.func.isRequired,
}

const defaultProps = {
  selectedItem: false,
}

class DropdownContainer extends Component {
  constructor() {
    super()

    this.onSelectChange = this.onSelectChange.bind(this)
  }

  onSelectChange(val) {
    const { onSelectChange } = this.props

    // call parent onSelectChange method
    if (typeof onSelectChange === 'function') {
      onSelectChange(val)
    }
  }

  render() {
    const { items, selectedItem, title, unselectedText } = this.props

    return (
      <Dropdown
        items={items}
        selectedItem={selectedItem}
        onSelectChange={this.onSelectChange}
        title={title}
        unselectedText={unselectedText}
      />
    )
  }
}

DropdownContainer.propTypes = propTypes
DropdownContainer.defaultProps = defaultProps

export default DropdownContainer
